<template>
  <v-container fluid class="pa-0">
    
    <v-row no-gutters v-if="customer">
      <v-col cols="12">
        <UltimateTz v-if="partnerCode==='ultimate_tz' || partnerCode==='two_tz'" />
        <CustomerDetail :customer="customer" v-else />
      </v-col>
    </v-row>

    <v-row no-gutters v-else>
      <v-col cols="12">
        <v-skeleton-loader type="list-item-avatar-three-line, article" />
      </v-col>
    </v-row>

  </v-container>
</template>


<script>

  import CustomerDetail from '@/views/customers/components/CustomerDetail';
  import UltimateTz from '@/views/customers/partners/ultimate_tz/Show';

  export default {

    components: {
      CustomerDetail,
      UltimateTz,
    },

    props: ['uuid'],

    data: () => ({
    }),

    computed: {
      partnerCode() { return this.$store.getters.settings.partnerCode; },
      customer() { return this.$store.getters.customer(this.uuid); },
    },

    watch: { 
      uuid: {
        immediate: true,
        handler(to) {
          this.$store.dispatch('addCustomersToCache', [to]);
        },
      },
    }

    // methods: {
    //   submit(farmer) {
    //     this.$store.dispatch('upsertFarmer', farmer);
    //   }
    // }

  }
</script>
